import { createFileRoute } from '@tanstack/react-router';
import { AgencyPage } from '../features/supply/agency/AgencyPage/AgencyPage';
import { agencyRouteSearchSchema } from '../features/supply/agency/agencyRouteSearch';

export const Route = createFileRoute('/campaigns/agencies')({
  validateSearch: agencyRouteSearchSchema,
  component: AgencyPage,
});
